import config from 'src/config';

import httpClient from '@helpers/httpClient';

const END_POINT = 'v1/learning-path';

export const LEARNING_PATH_END_POINT = {
  GET_LIST: `${END_POINT}/search`,
};

export default {
  fetchLearningPathList(path: string) {
    const apiUrl = new URL(path, config.API_DOMAIN);
    return httpClient
      .get(apiUrl.toString(), { isPublic: true })
      .then((res) => res.data)
      .catch((error) => error);
  },
  fetchLearningPath(id: number) {
    const apiUrl = new URL(`${END_POINT}/my/detail/${id}`, config.API_DOMAIN);
    return httpClient
      .get(apiUrl.toString(), { isPublic: true })
      .then((res) => res.data)
      .catch((error) => error);
  },
};
